import { render, staticRenderFns } from "./configuration-di-form.vue?vue&type=template&id=0693d610&scoped=true&lang=pug"
import script from "./configuration-di-form.vue?vue&type=script&lang=ts"
export * from "./configuration-di-form.vue?vue&type=script&lang=ts"
import style0 from "./configuration-di-form.vue?vue&type=style&index=0&id=0693d610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0693d610",
  null
  
)

export default component.exports